export const substituteUrl = (url, kwargs) => {
  if (kwargs) {
    Object.keys(kwargs).map(key => {
      url = url.replace(':' + key, kwargs[key]);
      return url;
    });
  }
  return url;
};
